exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3fqmkvjpk7FhJrap-_ivjN{display:-webkit-box;display:-ms-flexbox;display:flex}._2sVgKR9OpLjjLaZ3pOXHFX{height:20px;width:20px}", ""]);
// Exports
exports.locals = {
	"option": "_3fqmkvjpk7FhJrap-_ivjN",
	"iconContainer": "_2sVgKR9OpLjjLaZ3pOXHFX"
};